import Rest from '@services/Rest';

/**
 * @typedef {WithdrawGroupService}
 */
export default class WithdrawGroupExportService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/withdraw/group/export'
}
